export default [
  {
    code: 'WATER_GATE',
    label: 'Pintu Air'
  },
  {
    code: 'WATER_PUMP',
    label: 'Pompa Air'
  },
  {
    code: 'Shelter',
    label: 'Penampungan'
  }
]